import React from "react";
import { useParams } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useCart } from "../context/CartContext";
import nftData from "../data/nfts";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/NFTDetails.css"; // import CSS

const NFTDetails = () => {
  const { id } = useParams();
  const { addToCart } = useCart();

  // Find the NFT by id
  const nft = nftData.find((n) => n.id === parseInt(id, 10));
  if (!nft) return <h2 className="text-center mt-5">NFT not found</h2>;

  // Use priceETH and priceUSD directly from nftData
  const nftEth = nft.priceETH || "0 ETH";
  const nftUsd = nft.priceUSD || "$0.00 USD";

  const handleAdd = () => {
    addToCart(nft);
    toast.success("✅ NFT added to cart!", {
      position: "top-right",
      autoClose: 1800,
      hideProgressBar: true,
    });
  };

  const handleBuyNow = () => {
    toast.info("💳 Proceeding to checkout…", {
      position: "top-right",
      autoClose: 1800,
      hideProgressBar: true,
    });
  };

  return (
    <Container className="nft-details-container">
      <Row className="align-items-center g-4">
        <Col xs={12} md={6}>
          <div className="nft-image-wrapper">
            <img src={nft.image} alt={nft.name} />
          </div>
        </Col>
        <Col xs={12} md={6} className="nft-info">
          <h2>{nft.name}</h2>
          <p className="text-muted">By {nft.artist}</p>
          <p className="nft-price">
            {nftEth} ({nftUsd})
          </p>

          <div className="nft-buttons">
            <Button variant="success" onClick={handleBuyNow}>
              Buy Now
            </Button>
            <Button variant="warning" onClick={handleAdd}>
              Add to Cart
            </Button>
          </div>

          <p className="italic-note">
            ✨ Own this NFT, support the artist, and join the digital art revolution! ✨
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default NFTDetails;
